import { Outlet } from "react-router-dom";
import Navbar from "../components/CoreComponents/NavBar/NavBar";
import { Suspense } from "react";
import ProgressLoader from "../components/CoreComponents/ProgressLoader";
import { DownloadUserRelatedData } from "../components/DownloadManager/DownloadManager";
import { useUserVerification } from "../components/Providers/UserVerificationContext";
import InitialVerificationLoader from "../components/CoreComponents/InitialVerificationLoader";

export default function RouterLayout() {
  const { isVerifyingUser } = useUserVerification();
  const loaders = DownloadUserRelatedData();
  const {
    isProjectsLoading, isPunchlistLoading, isTasksLoading, isDisciplineLoading, isLinkDisciplineTechCategoryLoading, isOnHoldCausesLoading
    , isIssuesLoading, isStatusLoading, isCategoriesLoading, isLogsLoading, isRootCausesLoading, isBusinessUnitsLoading
    , isLogsTypesLoading, isCommentsLoading, isUsersLoading, isFilesLoading, isTechnologyLoading, isLinkDisciplineIssueLoading
    , isModelsLoading, isRelatedChecklistDetailsLoading, isPunchlistImagesLoading, isPunchlistOptionsLevelOneLoading, isPunchlistOptionsLevelTwoLoading
    , isAccessLevelsLoading
  } = loaders;

  const isLoading =
    isProjectsLoading || isPunchlistLoading || isTasksLoading || isDisciplineLoading || isOnHoldCausesLoading
    || isIssuesLoading || isStatusLoading || isCategoriesLoading || isLogsLoading
    || isLogsTypesLoading || isCommentsLoading || isUsersLoading || isFilesLoading || isBusinessUnitsLoading
    || isModelsLoading || isRelatedChecklistDetailsLoading || isTechnologyLoading
    || isPunchlistImagesLoading || isPunchlistOptionsLevelOneLoading || isLinkDisciplineIssueLoading
    || isPunchlistOptionsLevelTwoLoading || isRootCausesLoading || isLinkDisciplineTechCategoryLoading
    || isAccessLevelsLoading;

  // Show user verification loader first
  if (isVerifyingUser) {
    return <InitialVerificationLoader />;
  }

  return (
    <>
      {isLoading ? (
        <ProgressLoader loaders={loaders} />
      ) : (
        <div className="p-6">
          <div>
            <Navbar />
          </div>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </div>
      )}
    </>
  );
}